/* eslint-disable import/no-cycle */
import {action, decorate, observable} from 'mobx';
import {Api} from '../middleware/api';
import {EntityStore} from './entityStore';
import {InspectionTaskResult} from '../models/inspectionTaskResult';

export class InspectionTaskResultStore extends EntityStore {
  inspectionTaskResults = [];

  constructor(rootStore) {
    super(rootStore, 'inspectionTaskResults', Api.inspectionTaskResult, InspectionTaskResult);
  }

  getDependencies() {
    return [
      {
        store: this.rootStore.inspectionTaskStore,
        modelId: 'inspectionTaskId',
      },
    ];
  }

  getByInspectionTaskId(inspectionTaskId) {
    return this.inspectionTaskResults.filter((r) => r.inspectionTaskId === inspectionTaskId);
  }

  loadByInspectionTaskId(inspectionTaskId) {
    return this.loadAll({params: {inspectionTaskId}});
  }
}

decorate(InspectionTaskResultStore, {
  inspectionTaskResults: observable,
  loadByInspectionTaskId: action,
});
